import { measures, font, zIndexes } from 'styles/variables'
import { css } from '@emotion/core'

const { half } = measures

export default {
  container: css`
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    z-index: ${zIndexes.dropdown};
    font-family: ${font.family};
  `,
  dropDown: css`
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: ${half}px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: ${half}px;
    z-index: ${zIndexes.dropdown};
  `,
}
